module.exports = "/_next/static/media/upgrade-button-sequence.64233f28.png";